import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';

function isMenuItem(route) {
  return (route.path && route.label) || route.type === 'divider';
}

function mapRouteToMenuItem({ path, route }) {
  if (route.type) return route;

  const key = route.key || route.path;

  let children = route.children?.filter(isMenuItem);

  if (!children?.length && route.emptyLabel) {
    children = [{ key: `${route.path}/empty`, label: route.emptyLabel, disabled: true, link: false }];
  }

  return {
    key,
    label: route.link !== false ? <Link to={route.path}>{route.label}</Link> : route.label,
    children: children?.length ? children.map(r => mapRouteToMenuItem({ path, route: r })) : null,
    icon: route.icon,
    disabled: route.disabled,
    title: route.label,
  };
}

export function routesToMenuItems({ path, routes }) {
  return routes.filter(isMenuItem).map(route => mapRouteToMenuItem({ path, route }));
}

export function generateRoutes(routes) {
  const mapRoute = (route) => {
    const childRoutes = [];

    if (route.children) {
      childRoutes.push(...route.children);
    }

    if (route.dynamicItems?.length) {
      if (childRoutes.length) {
        childRoutes.push({ type: 'divider' });
      }
      childRoutes.push(...route.dynamicItems);
    }

    if (route.manage) {
      if (childRoutes.length) {
        childRoutes.push({ type: 'divider' });
      }
      childRoutes.push({ ...route.manage, icon: <EditOutlined /> });
    }

    return {
      ...route,
      children: childRoutes.length ? childRoutes.map(mapRoute) : null,
    };
  };

  return routes?.map(mapRoute);
}
